import PropTypes from 'prop-types';
import { megaMenuPropTypes } from './components/MegaMenu/MegaMenuPropTypes';
const mobileCategoryPropType = PropTypes.shape({
  label: PropTypes.string,
  href: PropTypes.string,
  picture: PropTypes.shape({
    src: PropTypes.string,
    alt: PropTypes.string
  })
});
export const navPropTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    badge: PropTypes.string,
    breakpoint: PropTypes.shape({
      mobile: PropTypes.bool,
      desktop: PropTypes.bool
    }),
    variant: PropTypes.string,
    items: PropTypes.oneOfType([megaMenuPropTypes.items, PropTypes.arrayOf(mobileCategoryPropType)])
  })),
  isMobileOpen: PropTypes.bool,
  isSearching: PropTypes.bool
};